import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { ImageSquare } from "@phosphor-icons/react";

// Tracker photos are served from an authenticated endpoint (private per-project access),
// so a plain <img src> won't work — fetch as a blob and hand the browser an object URL.
export function TrackerImg({ photoId, className, alt = "" }) {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let blobUrl;
    let cancelled = false;
    setFailed(false);
    if (!photoId) { setUrl(""); return; }
    api.get(`/tracker/photos/${photoId}/file`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        blobUrl = URL.createObjectURL(res.data);
        setUrl(blobUrl);
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [photoId]);

  if (!photoId || failed) {
    return (
      <div className={`${className} flex items-center justify-center bg-neutral-100 text-neutral-400`}>
        <ImageSquare size={24} weight="thin" />
      </div>
    );
  }
  if (!url) return <div className={`${className} bg-neutral-100 animate-pulse`} />;
  return <img src={url} alt={alt} className={className} />;
}
